<template>
  <v-navigation-drawer  v-model="drawer" v-if="show && user && !user.tecnico" app color="white" permanent right mini-variant
    mini-variant-width="80">
    <v-avatar class="d-block text-center mx-auto mt-4" size="40">
      <v-icon color="grey" large>person</v-icon>
    </v-avatar>

    <v-divider class="mx-3 my-5"></v-divider>

    <v-list flat class="mt-5">
      <v-list-item-group v-model="selectedItem">
        <v-list-item v-for="(item, i) in items" :key="i" :ripple="false" :disabled="item.disabled"
          @click="handleClick(i)">
          <v-list-item-icon>
            <v-badge bordered :content="item.messages" :value="item.messages" color="orange" overlap>
              <v-btn icon :disabled="item.disabled" :class="{ 'selected-btn': selectedItem === i }">
                <v-icon :color="item.color" v-text="item.icon"></v-icon>
              </v-btn>
            </v-badge>
          </v-list-item-icon>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <div
      style="position: absolute; bottom: 20px; margin-left: auto; margin-right: auto; left: 0; right: 0; text-align: center;">
      <v-btn icon :ripple="false">
        <v-badge bordered overlap color="red" dot>
          <v-icon>far fa-bell</v-icon>
        </v-badge>
      </v-btn>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { EventBus } from '../main'
import medicoService from '../services/medico.service'

export default {
  data: () => ({
    selectedItem: 0, // Index do item selecionado
    drawer: true,
    user: null,
    show: true,
    qtdLaudos: 0,
    load: false,
    items: [
      { icon: 'fas fa-bars', color: 'indigo', label: 'Tela Inicial', disabled: false, messages: 0 },
      { icon: 'fas fa-user-md', color: 'primary', label: 'Atendimento', disabled: false, messages: 0 },
      { icon: 'fas fa-file-text', color: 'blue-grey', label: 'Agenda Médico', disabled: false, messages: 0 },
      { icon: 'fas fa-wallet', color: 'orange', label: 'Financeiro', disabled: true, messages: 0 }
    ]
  }),
  methods: {
    handleClick (index) {
      const item = this.items[index]
      if (!item.disabled) {
        this.selectedItem = index // Atualiza o índice do item selecionado
        this.$emit('selecionado', index)
      }
    },
    quantidadeLaudosTec () {
      this.load = false
      if (!this.user || !this.user.idPrestador) return
      medicoService.medico.quantidadeLaudosTec(this.user.idPrestador).then(r => {
        if (r && r.status === 200 && r.data) {
          this.items[2].messages = r.data.msg
        }
      }).finally(() => {
        this.load = false
      })
    }
  },
  mounted () {
    EventBus.$on('showSideBar', (data) => {
      this.show = data
    })
    EventBus.$on('reloadQuantidadeLaudosTec', (data) => {
      this.quantidadeLaudosTec()
    })
    this.user = this.$store.getters.usuario
    this.quantidadeLaudosTec()
  },
  beforeDestroy: function () {
    EventBus.$off('showSideBar')
  }
}
</script>

<style>
/* Estilo para o item selecionado */
.selected-item {
  background: rgba(0, 188, 212, 0.1);
  /* Destaque leve para o item selecionado */
  border-radius: 50%;
}

/* Estilo para o botão selecionado */
.selected-btn {
  background: rgba(0, 188, 212, 0.2);
  /* Cor de fundo diferenciada */
}

/* Estilo para itens desabilitados */
.v-list-item[disabled] {
  opacity: 0.4;
  pointer-events: none;
}
</style>
